import axiosHelper from "axios";

axiosHelper.interceptors.request.use(function (request) {
	// Do something before request is sent
	const session = (document.getElementById("control_session") as HTMLInputElement)?.value ?? null;
	const thread = (document.getElementById("control_thread") as HTMLInputElement)?.value ?? null;

	try {
		if (session && thread) {
			if (request?.params) {
				request.params['session'] = session
				request.params['thread'] = thread
			}

			if (request?.data instanceof FormData) {
				request.data.append('session', session)
				request.data.append('thread', thread)
			}
		}
	} catch (e) {
		console.warn("Error while setting session and thread id", e)
	}

	return request;
}, function (error) {
	// Do something with request error
	return Promise.reject(error);
});

axiosHelper.interceptors.response.use(function (response) {

	return response;
}, function (error) {
	// Check if error.response exists before accessing properties
	if (error.response && error.response.status === 401) {
		location.reload();
		return;
	}

	return Promise.reject(error);
});

export default axiosHelper;